<template>
    <el-popover ref="referInfo" v-if="data.type == 'bibr' || data.type == 'fn'" trigger="click" popper-class="jom-refer-info theme-border">
        <div v-if="data.type == 'bibr'" style="word-wrap: break-word" :class="{'fontsize-1080':is1080P()}">
            <div class="jom-refer-title">{{ARTICLE.defaultlang=='en'?'Reference' : '参考文献'}} {{ data.text }}</div>
            <!--<div v-html="citation" class="jo-refer-content"></div>-->
          <span v-for="item2 in citation" class="jom-refer-content">
            <component v-if="item2.name!='extlink'" :is="'jo' + item2.name" v-bind:key="item2.index"
                       v-bind:data="item2.data"></component>
            <component v-else :is="'jo' + linkItem.name" v-for="linkItem in item2.data.text" v-bind:key="linkItem.index"
                       v-bind:data="linkItem.data"></component>
          </span>
          <br v-if="citation.length>0" class="jom-refer-content"/>
          <span v-for="item3 in citationEn">
            <component v-if="item3.name!='extlink'" :is="'jo' + item3.name" v-bind:key="item3.index" v-bind:data="item3.data"></component>
            <component v-else :is="'jo' + linkItem.name" v-for="linkItem in item3.data.text" v-bind:key="linkItem.index"
                   v-bind:data="linkItem.data"></component>
          </span>

          <div class="jom-refer-origin-div" v-if="showLink">
            <a class="jom-refer-origin" v-if="showGoogle" :href="'https://scholar.google.com/scholar_lookup?author='+author+'&title='+title" target="_blank">Google Scholar</a>
            <a class="jo-refer-origin" v-if="showBaidu" :href="'https://xueshu.baidu.com/s?wd='+title+'&site=xueshu_se'" target="_blank">
              {{ARTICLE.defaultlang=='en'?'Baidu Scholar' : '百度学术'}}&nbsp;&nbsp;&nbsp;&nbsp;</a></div>
        </div>
        <div v-else-if="data.type == 'fn'" :class="{'fontsize-1080':is1080P()}">
            <div class="jom-refer-title">脚注</div>
            <span class="jom-refer-content"><component :is="'jo' + item.name" v-for="item in citation" v-bind:key="item.index" v-bind:data="item.data"></component></span>
        </div>
        <span v-if="data.type == 'bibr'" class="jom-refer-sup theme-font" slot="reference" @click="showDetail()">
          <component :is="'jo' + item.name" v-for="item in data.data" v-bind:key="item.index" v-bind:data="item.data"></component></span>
      <svg v-else-if="data.type == 'fn' && !this.hideFootnote" slot="reference" t="1627368677694" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2898"
           xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" @click="showDetail()">
        <path d="M832 64 192 64C121.6 64 64 121.6 64 192l0 512c0 70.4 57.6 128 128 128l128 0 132.096 120.448C459.072 957.632 466.88 960 474.432 960 493.824 960 512 944.704 512 922.496L512 832l320 0c70.4 0 128-57.6 128-128L960 192C960 121.6 902.4 64 832 64zM736 576l-448 0C270.336 576 256 561.664 256 544S270.336 512 288 512l448 0C753.664 512 768 526.336 768 544S753.664 576 736 576zM736 384l-448 0C270.336 384 256 369.664 256 352S270.336 320 288 320l448 0C753.664 320 768 334.336 768 352S753.664 384 736 384z"
              p-id="2899" :fill="ARTICLE.theme"></path>
      </svg>
    </el-popover>
  <nobr v-else><joanchor :data="data"></joanchor></nobr>
</template>

<script>
    export default {
        data(){
            return {
                citation:[],
                title:'',
              citationEn: [],
              author:''
            }
        },
        props: [
            'data'
        ],
        methods: {
          showDetail() {
            if (this.data.type == 'bibr') {
              let _citation = []
              let _citationEn = []
              for (var i in this.ARTICLE.reflist.data) {
                if (this.ARTICLE.reflist.data[i].id == this.data.rid) {
                  if (this.ARTICLE.reflist.data[i].citation.length === 1) {
                    _citation = _citation.concat(this.ARTICLE.reflist.data[i].citation[0].text)
                    this.setTitle(this.ARTICLE.reflist.data[i].citation[0]);
                  }
                  else if (this.ARTICLE.reflist.data[i].citation.length > 1) {
                    for (let j in this.ARTICLE.reflist.data[i].citation){
                      if (this.ARTICLE.reflist.data[i].citation[j].lang===this.ARTICLE.defaultlang){
                        _citation = _citation.concat(this.ARTICLE.reflist.data[i].citation[j].text)
                        this.setTitle(this.ARTICLE.reflist.data[i].citation[j]);
                      }else _citationEn = _citationEn.concat(this.ARTICLE.reflist.data[i].citation[j].text)
                    }
                  }
                }
              }
              this.citation = _citation;
              this.citationEn = _citationEn;
            } else if (this.data.type == 'fn') {
              for (var i in this.ARTICLE.footnote) {
                if (this.ARTICLE.footnote[i].id == this.data.rid) {
                  this.citation = this.ARTICLE.footnote[i].text
                }
              }
            }
            this.author = this.citation[0].data;
          },
          setTitle(citation){
            if (citation.title && citation.title!==''){
              this.title = citation.title;
            }else {
              for (let i in citation.text){
                this.title = this.title + citation.text[i].data;
              }
            }
          },
          is1080P(){
            let dpRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
            return window.screen.width*dpRatio >= 1080
          }
        },
    }
</script>

<style lang="scss" scoped>
  .fontsize-1080{
    .jom-refer-title {
      font-size: 1.6rem;
    }
    .jom-refer-content{
      font-size:1.4rem;
      line-height:1.8rem;
    }
  }
  .jom-refer-title {
      font-weight: bold;
      color: #333;
  }
  .jom-refer-content{
      font-size:12px;
      line-height:18px;
  }
  .jo-refer-content{
    word-wrap:break-word;
  }
  .jom-refer-origin-div{
    white-space: nowrap;
    margin-top: 5px;
  }
  .jom-refer-origin{
      float: right;
      font-size: 12px;
      font-weight: bold;
      color: #009999;
      text-decoration:none;
    white-space: nowrap;
  }
  .jom-refer-sup{
      color: #00a2af;
      cursor: pointer;
    white-space: nowrap;
  }
  .jom-refer-sup:hover {
      text-decoration: underline;
  }
  .footnote-sup{
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/common/xref.vue